<template>
  <div class="position-relative">
    <!--主頁面 -->
    <Stage_1/>
    <!--要烤出一條脆皮豬-->
    <Stage_2/>
    <!--美味的享用方式-->
    <div id="how_to_eat"/>
    <Stage_3/>
    <!--關注我們-->
    <div id="follow"/>
    <Stage_4/>
    <!--品牌故事-->
    <div id="story"/>
    <Stage_5/>
    <!--加盟優勢-->
    <div id="advantage"/>
    <Stage_6/>
    <!--認識更多滿香脆-->
    <Stage_7/>
    <!--分店資訊-->
    <div id="store"/>
    <Stage_8/>
    <!--立即品嘗-->
    <div id="taste_now"/>
    <Stage_9/>
    <!--常見問題-->
    <div id="faq"/>
    <Stage_10/>
    <FabWidget/>
  </div>
</template>

<script>
import Glide from "@/components/Glide";
import DatePickers from "./components/JavascriptComponents/DatePickers";
import Stage_1 from "./home/Stage_1";
import Stage_2 from "./home/Stage_2";
import Stage_3 from "./home/Stage_3";
import Stage_4 from "./home/Stage_4";
import Stage_5 from "./home/Stage_5";
import Stage_6 from "./home/Stage_6";
import Stage_7 from "./home/Stage_7";
import Stage_8 from "./home/Stage_8";
import Stage_9 from "./home/Stage_9";
import Stage_10 from "./home/Stage_10";
import FabWidget from "../components/FabWidget";

export default {
  name: "home",
  components: {
    DatePickers, Glide: Glide,
    Stage_1, Stage_2, Stage_3,
    Stage_4, Stage_5, Stage_6,
    Stage_7, Stage_8, Stage_9,
    Stage_10, FabWidget
  },
  data() {
    return {};
  },
  mounted() {
  },
  watch: {
    $route(to, from) {
      console.log("$route to ", to) // 目的地
      console.log("$route from ", from) // 原地
    }
  },
  created() {
    // this.getSetting();
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>


</style>
